<template>
  <div class="nomore">
    <img
      class="nomore_img"
      src="@/assets/schoolScreen/school_overview/nomore.png"
      alt=""
    />
    <div class="t">{{ description }}</div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  props: {
    description: {
      type: String,
      default: "暂无数据哦~",
    },
  },
  data() {
    return {};
  },
  methods: {},
  watch: {},
  computed: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.nomore {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  .nomore_img {
    height: 168px;
  }
  .t {
    margin-top: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    background-clip: text !important;
    -webkit-background-clip: text !important; /*将设置的背景颜色限制在文字中*/
    -webkit-text-fill-color: transparent; /*给文字设置成透明*/
    background: linear-gradient(to bottom, #ffffff 0%, #13cfff 100%);
  }
}
</style>
